const STYLE = `
  #help-overlay { position: fixed; inset: 0; background: #1d352966; display: none; z-index: 100; justify-content: center; align-items: center; font: 15px system-ui, sans-serif; color: #314338; }
  #help-overlay.show { display: flex; }
  #help-card { background: #fffdf5; border: 2px solid #b9d8aa; border-radius: 20px; box-shadow: 0 12px 32px #1d352966; padding: 28px 36px; max-width: 520px; width: 90%; max-height: 80vh; overflow-y: auto; }
  #help-card h2 { margin: 0 0 16px; font-size: 20px; color: #31583b; }
  #help-card h3 { margin: 14px 0 6px; font-size: 14px; color: #42694b; text-transform: uppercase; letter-spacing: .5px; }
  #help-card table { width: 100%; border-collapse: collapse; }
  #help-card td { padding: 4px 0; vertical-align: top; }
  #help-card td:first-child { width: 44%; color: #42694b; font-weight: 600; }
  #help-card td:last-child { color: #314338; }
  #help-card .tip { background: #eef7e9; border-left: 3px solid #79b889; padding: 8px 12px; margin: 10px 0; border-radius: 0 10px 10px 0; font-size: 13px; color: #314338; }
  #help-card .close { display: block; margin: 18px auto 0; background: #79b889; color: #173420; border: 2px solid #dff2d8; border-radius: 999px; box-shadow: 0 3px 0 #42694b; padding: 8px 24px; font-size: 15px; font-weight: 600; cursor: pointer; }
  #help-card .close:hover { background: #a7d198; }
`;

const HTML = `
  <div id="help-card">
    <h2>How to Play</h2>

    <h3>Movement</h3>
    <table>
      <tr><td>WASD / Arrow keys</td><td>Walk around</td></tr>
      <tr><td>Left stick / D-pad</td><td>Walk around (gamepad)</td></tr>
      <tr><td>Click on ground</td><td>Walk to that spot (click Kuki first)</td></tr>
    </table>

    <h3>Gamepad Controls</h3>
    <table>
      <tr><td>A button</td><td>Interact with nearest object</td></tr>
      <tr><td>B button</td><td>Close menu / Cancel</td></tr>
      <tr><td>X button</td><td>Toggle backpack</td></tr>
      <tr><td>Start (+)</td><td>Toggle sound settings</td></tr>
      <tr><td>Capture</td><td>Toggle minimap</td></tr>
    </table>

    <h3>Interacting with Objects</h3>
    <table>
      <tr><td>Click on any object</td><td>See available actions</td></tr>
      <tr><td>Drag an object</td><td>Move it around</td></tr>
      <tr><td>Place on surface</td><td>Drag onto a table or shelf</td></tr>
    </table>

    <h3>Artifacts &amp; Discovery</h3>
    <table>
      <tr><td>Inspect</td><td>Reveal an artifact's true identity</td></tr>
      <tr><td>Examine</td><td>Study a discovered artifact more closely</td></tr>
      <tr><td>Rub</td><td>Clean a tarnished mineral or coin</td></tr>
      <tr><td>Combine</td><td>Merge two items into something new</td></tr>
      <tr><td>Look</td><td>Read a description</td></tr>
    </table>

    <div class="tip">Tip: Some objects are hidden. Try moving things around to find secrets!</div>

    <h3>Inventory &amp; Clothing</h3>
    <table>
      <tr><td>Take</td><td>Pick up an item into your backpack</td></tr>
      <tr><td>Wear (on clothing)</td><td>Put on directly — no backpack needed</td></tr>
      <tr><td>Drop</td><td>Click an inventory item, then click the ground</td></tr>
      <tr><td>Wear (from backpack)</td><td>Click an inventory item, then click Kuki</td></tr>
      <tr><td>Remove</td><td>Take off worn clothing from the backpack panel</td></tr>
    </table>


    <h3>Navigation</h3>
    <table>
      <tr><td>Doors &amp; gates</td><td>Click to move between scenes</td></tr>
      <tr><td>🗺 Map</td><td>Toggle the minimap overview</td></tr>
    </table>

    <div class="tip">Tip: The knowledge you gain from inspecting artifacts unlocks new things to discover. Explore everything!</div>

    <button class="close">Got it!</button>
  </div>
`;

export function createHelpOverlay(): { toggle(): void; close(): void; readonly element: HTMLElement } {
  const style = document.createElement("style");
  style.textContent = STYLE;
  document.head.appendChild(style);

  const el = document.createElement("div");
  el.id = "help-overlay";
  el.innerHTML = HTML;
  document.body.appendChild(el);

  el.addEventListener("click", (e) => {
    if (e.target === el) el.classList.remove("show");
  });
  el.querySelector(".close")!.addEventListener("click", () => el.classList.remove("show"));

  return {
    toggle() { el.classList.toggle("show"); },
    close() { el.classList.remove("show"); },
    get element() { return el; },
  };
}
